import styled from 'styled-components';
export const Frame = styled.div `
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: clamp(1.25rem, 7.8125vw, 2.5rem) clamp(1.25rem, 6.25vw, 2rem);
    background: rgba(180, 180, 180, 0.15);
    box-shadow: inset 0px 0px 0.125rem rgba(255, 255, 255, 0.8);
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12), inset 0px 0px 2px rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5rem);
    -webkit-backdrop-filter: blur(5rem);
    border-radius: 2.75rem;
`;
